//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  NAVITEM_VARIANT_DEFAULT,
  NAVITEM_VARIANT_LIGHT_BLUE,
} from '../../utils/constants'
export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      required: false,
      default: null,
    },
    to: {
      type: [String, Object],
      required: false,
      default: null,
    },
    componentClass: {
      type: String,
      required: false,
      default: null,
    },
    variant: {
      type: String,
      default: NAVITEM_VARIANT_DEFAULT,
      validator: (x) =>
        [NAVITEM_VARIANT_DEFAULT, NAVITEM_VARIANT_LIGHT_BLUE].includes(x),
    },
  },
  computed: {
    tag() {
      if (this.href) {
        return 'a'
      }

      if (this.to) {
        return 'nuxt-link'
      }

      return 'span'
    },
    bound() {
      switch (this.tag) {
        case 'a':
          return { href: this.href }
        case 'nuxt-link':
          return { to: this.to }
        default:
          return {}
      }
    },
    classes() {
      const cls = []

      switch (this.variant) {
        case NAVITEM_VARIANT_DEFAULT:
          cls.push('tw-text-gray-800')
          if (this.active) {
            cls.push('tw-bg-gray-100')
          } else {
            cls.push('hover:tw-bg-gray-50')
          }
          break
        case NAVITEM_VARIANT_LIGHT_BLUE:
          if (this.active) {
            cls.push('tw-bg-blue-100 tw-text-blue-800')
          } else {
            cls.push('hover:tw-bg-blue-50')
          }
          break
      }

      if (this.tag === 'span') {
        cls.push('tw-cursor-default')
      } else {
        cls.push('tw-cursor-pointer tw-no-underline hover:tw-no-underline')
      }

      if (this.componentClass) {
        cls.push(this.componentClass)
      }

      return cls
    },
  },
}
